import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../Layout/Layout";
import ProviderProductWizard from "./ProviderProductWizard";
import DropshippingInterneLayout from "../components/DropshippingInterneLayout";
import ProviderNotice from "../center/ProviderNotice";
import { elakayAutoText } from "../../pageInside/dataElakay";
import "../seller/DropshippingIn.css";

// spec §11 -- Provider Add Product : wizard Categories -> Info -> Filters ->
// Images (ProviderProductWizard.jsx), même workflow que Sell Your Product.
// Edit (ProviderEditProduct.jsx) garde le formulaire unique ProviderProductForm ;
// les sections commerciales sont partagées via ProviderCommercialSections.
// spec §1/§2 (menu Dropshipping In) -- rendue à travers le vrai Layout
// Elakay + le sous-menu partagé, comme toutes les pages du module.
const ProviderAddProduct = ({ infoSource }) => {
  return (
    <Layout
      infoSource={infoSource}
      titleElakay="providerAddProduct"
      SliderPunShow={false}
      loading={false}
      outOffPage={false}
      {...infoSource?.allSettings?.layout}
      showFooter={true}
    >
      <DropshippingInterneLayout infoSource={infoSource}>
        <nav className="dsi-breadcrumb" aria-label={elakayAutoText("h_c766e665183df1", "Breadcrumb")}>
          <Link to="/provider">{elakayAutoText("h_pvc_title", "Provider Center")}</Link>
          <span aria-hidden="true">›</span>
          <Link to="/provider/products">{elakayAutoText("h_ea6ea55069ee28", "My Products")}</Link>
          <span aria-hidden="true">›</span>
          <span aria-current="page">{elakayAutoText("h_ee611e536d6eb1", "Add Product")}</span>
        </nav>
        <ProviderNotice />
        <ProviderProductWizard infoSource={infoSource} />
      </DropshippingInterneLayout>
    </Layout>
  );
};

export default ProviderAddProduct;
